export default "__VITE_PUBLIC_ASSET__e837c690__"